/**
 * Fase 1.5 (Contatos) — helpers de nome de exibição.
 *
 * Convenção do projeto (ADR-001): nomes operacionais sempre em UPPERCASE.
 *
 * Fallback chain para empresas:
 *   short_name → empresa (legado) → company_name
 *
 * short_name é o nome curto operacional (CONX, CYRELA, BTG); company_name
 * é o nome canônico em UPPERCASE (geralmente legal). Em automações (vCard,
 * email subject, WhatsApp, agentes) preferimos o curto.
 */

export function getCompanyDisplayName(company) {
  if (!company) return '';
  const value =
    (company.short_name && company.short_name.trim())
    || (company.empresa && company.empresa.trim())
    || (company.company_name && company.company_name.trim())
    || '';
  return value.toUpperCase();
}

export function getContactFullName(contact) {
  return [contact?.first_name, contact?.last_name]
    .filter(Boolean)
    .map((v) => String(v).trim())
    .filter(Boolean)
    .join(' ');
}

export function getContactContextLabel(company, contact) {
  const companyDisplay = getCompanyDisplayName(company);
  const contactName = getContactFullName(contact);
  if (companyDisplay && contactName) return `${companyDisplay} | ${contactName}`;
  return contactName || companyDisplay || '';
}
